import fetch from "isomorphic-fetch";
import { message, setIsFetching, setRoute } from "../../../actions";
import Configuration from "../../../config";
import ReactGA from "react-ga";

/**
 * Konstanten
 */
export const SET_ORGANIZATIONS_OVERVIEW = "SET_ORGANIZATIONS_OVERVIEW";

/**
 * Setter
 */
export function setOrganizationsOverview( json )
{
	return {
		type: SET_ORGANIZATIONS_OVERVIEW,
		json
	};
}

/**
 * Nutzt die Api um die Daten aller Benutzer im Store zu
 */
export function getOrganizationsOverview()
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Organization",
				action: "Organisationsliste laden"
			} );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		
		return fetch(
			`${Configuration.apiUrl}/organizations?${+new Date()}`,
			{
				credentials: "include",
				method: "GET",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						response.json()
							.then( json =>
								{
									dispatch( setOrganizationsOverview( json ) );
								}
							);
					}
					else
					{
						response.json()
							.then( json =>
								{
									switch ( response.status )
									{
										case 401:
										case 402:
										case 403:
										case 404:
										case 500:
											dispatch( setRoute( `/${response.status}` ) );
											break;
										default:
											break;
									}
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
		
	};
	
} // function getOrganizationsOverview()

/**
 * Lädt die gewählte Organisation im gewählten Format herunter
 *
 * @param a_organization {Object}
 * @param a_format {string}
 */
export function getOrganization( a_organization, a_format = "json" )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Organisation",
				action: "Organisation exportieren"
			} );
		}
		
		const { jwt } = { ...getState() };
		
		let headers = jwt !== null ? { "JWT": jwt } : {};
		
		return fetch(
			`${Configuration.apiUrl}/organizations/${a_organization.id}?format=${a_format}&${+new Date()}`,
			{
				credentials: "include",
				method: "GET",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						switch ( a_format )
						{
							case "csv":
								response.blob().then( blob =>
									{
										let newBlob = new Blob( [ blob ], { type: "text/csv" } );
										const fileName = `DATEV-Kunde ${a_organization.customer_number}.csv`;
										
										if ( window.navigator.msSaveOrOpenBlob )
										{
											window.navigator.msSaveOrOpenBlob( newBlob, fileName );
										}
										else
										{
											let url = URL.createObjectURL( newBlob );
											let a = document.createElement( "a" );
											document.body.appendChild( a );
											a.style = "display: none";
											a.href = url;
											a.download = fileName;
											a.click();
											
											URL.revokeObjectURL( url );
										}
										dispatch( setIsFetching( false ) );
									}
								);
								break;
							case "json":
								response.json()
									.then( json =>
										{
											//dispatch( setOrganization( json ) );
										}
									);
								break;
							default:
								break;
						}
						
					}
					else
					{
						response.json()
							.then( json =>
								{
									dispatch( message( json.error, "error" ) );
									dispatch( setIsFetching( false ) );
								}
							);
					}
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function getOrganization(...)

/**
 * Nutzt die Api um die Daten des Benutzers zu ändern und im Store zu speichern
 *
 * @param a_formData {Object}
 * @param a_udatedSet {Object}
 */
export function patchOrganization( a_formData, a_udatedSet )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Organisation",
				action: "Organisationsdaten ändern"
			} );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		headers["content-type"] = "application/json";
		
		return fetch(
			`${Configuration.apiUrl}/organizations/${a_udatedSet.id}?${+new Date()}`,
			{
				credentials: "include",
				method: "PATCH",
				body: JSON.stringify( a_formData ),
				headers
			}
		)
			.then(
				response =>
				{
					// Organisation geändert
					if ( response.ok )
					{
						let udatedSet = a_udatedSet;
						
						// Wenn der Bestellstatus angepasst wurde
						if ( udatedSet.hasOwnProperty( "order_status" ) )
						{
							switch ( udatedSet.order_status )
							{
								case "bestellt":
								case "bezahlt":
								case "entsperrt":
									udatedSet["active"] = true;
									break;
								case "gesperrt":
									udatedSet["active"] = false;
									break;
								default:
									udatedSet["active"] = false;
							}
						}
						
						// Datensatz anpassen und Overview aktualisieren
						const organizationsOverview = Object.assign(
							{},
							getState().organizations,
							{ [udatedSet.id]: udatedSet }
						);
						dispatch( setOrganizationsOverview( organizationsOverview ) );
						
						// Der Nutzer soll ein Alert erhalten, dass die Anfrage erfolgreich war.
						dispatch( message( "Organisationsdaten erfolgreich geändert.", "info", 5000 ) );
					}
					// Eingabefehler oder Serverfehler
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function patchOrganization()

/**
 * Nutzt die Api um die Daten des Benutzers zu ändern und im Store zu speichern
 *
 * @param a_udatedSet {Object}
 */
export function anonymizeIban( a_udatedSet )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Bestellung",
				action: "IBAN anonymisieren"
			} );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		headers["content-type"] = "application/json";
		
		return fetch(
			`${Configuration.apiUrl}/organizations/anonymize_iban/${a_udatedSet.id}?${+new Date()}`,
			{
				credentials: "include",
				method: "PATCH",
				headers
			}
		)
			.then(
				response =>
				{
					// Organisation geändert
					if ( response.ok )
					{
						response.json()
							.then( iban =>
								{
									// Datensatz anpassen und Overview aktualisieren
									const organizationsOverview = Object.assign(
										{},
										getState().organizations,
										{ [a_udatedSet.id]: { ...a_udatedSet, iban: iban } }
									);
									dispatch( setOrganizationsOverview( organizationsOverview ) );
									
									// Der Nutzer soll ein Alert erhalten, dass die Anfrage erfolgreich war.
									dispatch( message( "IBAN erfolgreich anonymisiert.", "info", 5000 ) );
								}
							);
					}
					// Eingabefehler oder Serverfehler
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function anonymizeIban()

/**
 * Api-Anfrage: Fragebogen löschen
 *
 * @param a_id {number}
 */
export function deleteOrganization( a_id )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Organisation",
				action: "Organisation mit allen zugehörigen Daten löschen"
			} );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		
		return fetch(
			`${Configuration.apiUrl}/organizations/${a_id}?${+new Date()}`,
			{
				credentials: "include",
				method: "DELETE",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						// Datensatz löschen und Overview aktualisieren
						delete getState().organizations[a_id];
						
						// Der Nutzer soll ein Alert erhalten, dass die Anfrage erfolgreich war.
						dispatch( message( "Organisation erfolgreich gelöscht.", "info", 5000 ) );
					}
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function deleteOrganization(...)